export default __webpack_public_path__ + "static/media/tg-logo.0371ed63.svg";